export interface Department {
  id: number;
  code: string;
  name: string;
  description: string | null;
  isActive: boolean | 0 | 1;
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
}

export interface DepartmentFormValues {
  code: string;
  name: string;
  description?: string;
  isActive: boolean;
  sortOrder: number;
}

export const isDepartmentActive = (department: Department) =>
  department.isActive === true || department.isActive === 1;
